/* eslint-disable import/prefer-default-export */
export const KPIChartTransformOption = (metrics, filterColor) => {
  const dataVarMetrics = metrics.map(metric => `data.results.${metric}`);
  const dataVar = [
    'data.timestamp',
    dataVarMetrics.join('|'),
  ];

  const aggregates = metrics.map(metric => `totals.${metric}`);
  const aggregateVar = aggregates.join('|');

  return {
    'out*data.results': [
      {
        id: '__seq__',
        color: [filterColor],
        xAxis: {
          type: 'time',
          show: false,
        },
        yAxis: {
          type: 'value',
          show: false,
        },
        grid: {
          left: 0,
          top: 5,
          right: 0,
          bottom: 5,
        },
        tooltip: {
          trigger: 'axis',
          show: true,
        },
        series: [{
          'data*data.timestamp': [
            dataVar,
          ],
          type: 'line',
          lineStyle: {
            width: 1,
          },
          symbol: 'circle',
          showSymbol: false,
          areaStyle: {
            opacity: 0,
          },
        }],
        _metric: 'metric.name',
        _title: 'metric.ovbDisplayName',
        _unit: 'metric.unit',
        _aggregate: aggregateVar,
      },
    ],
  };
};
